export const MAX_LEN_ANSWER_TEXT = 100;
export const MAX_LEN_ANSWER_EXTENDED_TEST_TEXT = 100;
export const MAX_LEN_ANSWER_CROSSWORD_TEXT = 15;
export const MAX_LEN_ANSWER_MEDIA_CAPTION = 150;
export const MAX_LEN_ANSWER_RESULT_TITLE = 140;
export const MAX_LEN_ANSWER_RESULT_SUBTITLE = 300;
export const MAX_LEN_ANSWER_RESULT_MEDIA_CAPTION = 150;
